import { render, staticRenderFns } from "./payment-plan.vue?vue&type=template&id=2b16d852&scoped=true"
import script from "./payment-plan.vue?vue&type=script&lang=ts"
export * from "./payment-plan.vue?vue&type=script&lang=ts"
import style0 from "./payment-plan.vue?vue&type=style&index=0&id=2b16d852&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16d852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b16d852')) {
      api.createRecord('2b16d852', component.options)
    } else {
      api.reload('2b16d852', component.options)
    }
    module.hot.accept("./payment-plan.vue?vue&type=template&id=2b16d852&scoped=true", function () {
      api.rerender('2b16d852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paymentV2/components/payment-plan.vue"
export default component.exports